import React, { FunctionComponent } from 'react';

import { Card } from 'components';
import { Button, Text } from 'components/chroma';
import { toAussieStandardDateFormat } from 'scenes/common/helpers/datetime';
import { Driver } from 'scenes/motor/types';

import { hasName } from './service/validation';

export const DriverCard: FunctionComponent<{
  driver: Driver;
  onEditReviewDriver: (index: number) => void;
}> = ({ driver, onEditReviewDriver }) => (
  <Card id={driver.dob} center justify tabIndex={-1} role="listitem">
    <div>
      {hasName(driver) && (
        <Text weight={600}>{`${driver.firstName} ${driver.lastName}`}</Text>
      )}
      <Text weight={500}>{`${driver.gender} - ${toAussieStandardDateFormat(
        driver.dob
      )}`}</Text>
    </div>
    <Button link onClick={onEditReviewDriver}>
      {`${hasName(driver) ? 'Edit' : 'Add'} Name`}
    </Button>
  </Card>
);
